var map = {
	"./work_shop_1.jpg": 4920,
	"./work_shop_2.jpg": 4100,
	"./work_shop_3.jpg": 5060,
	"./work_shop_4.jpg": 3402,
	"./work_shop_5.jpg": 6222,
	"./work_shop_6.jpg": 8881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4308;